import React from 'react';
import Footer from '../components/footer';
import Header from '../components/header';

export default function TermsPage() {
  return (
    <div className="container">
      <Header />
      
      <div className="container-fluid mt-5 pt-3">
        <div className="row">
          <div className="col-md-12 col-sm-12 border p-3">
            <section className="py-5">
              <div className="container">
                <div className="text-justify text-div">
                  <h2 className="mb-4">Terms of Service</h2>
                  <p className="lead">
                    Welcome to Clowza! These Terms of Service ("Terms") govern your access to and use of our website, services, and mobile applications (collectively, the "Platform"). Please read these Terms carefully before using the Platform.
                  </p>

                  <h4>1. Acceptance of Terms</h4>
                  <p>
                    By creating an account, accessing, or using Clowza, you agree to be bound by these Terms and our Privacy Policy. If you do not agree to these Terms, you may not access or use the Platform.
                  </p>

                  <h4>2. Eligibility and Account Registration</h4>
                  <p>
                    You must be at least 13 years old (or the minimum age of consent in your country) to use the Platform. You agree to provide accurate, current, and complete information during registration and to keep your account information updated. You are responsible for safeguarding your password and for all activities that occur under your account.
                  </p>

                  <h4>3. User Content and Conduct</h4>
                  <p>
                    Clowza is a scripture-based social media platform. You retain ownership of the content you post, but you grant Clowza a worldwide, non-exclusive, royalty-free license to use, copy, reproduce, process, adapt, modify, publish, transmit, and display such content.
                  </p>
                  <p>
                    You agree not to post any content or engage in behavior that:
                  </p>
                  <ul>
                    <li>Is unlawful, harmful, threatening, abusive, harassing, defamatory, or invasive of another's privacy.</li>
                    <li>Promotes hate speech, violence, discrimination, or illegal activities.</li>
                    <li>Involves Child Sexual Abuse and Exploitation (CSAE), Child Sexual Abuse Material (CSAM), grooming, sexualization of minors, or any content that depicts, describes, or seeks sexual activity involving anyone under 18 (real or fictional).</li>
                    <li>Infringes any patent, trademark, trade secret, copyright, or other proprietary rights of any party.</li>
                    <li>Contains software viruses or any other computer code designed to interrupt, destroy, or limit functionality.</li>
                    <li>Impersonates any person or entity, or falsely states or misrepresents your affiliation.</li>
                  </ul>

                  <h4>4. Child Safety Standards</h4>
                  <p>
                    Clowza has zero tolerance for Child Sexual Abuse and Exploitation (CSAE). Our full Child Safety Standards,
                    including how to report concerns and how we respond to CSAM/CSAE, are published at{' '}
                    <a href="https://clowza.com/child-safety-standards.html">
                      https://clowza.com/child-safety-standards.html
                    </a>
                    {' '}and also available on this site at{' '}
                    <a href="/child-safety-standards">/child-safety-standards</a>.
                    Child safety reports may be sent to{' '}
                    <a href="mailto:clowzateam@gmail.com">clowzateam@gmail.com</a>.
                  </p>

                  <h4>5. Platform Rules and Guidelines</h4>
                  <p>
                    We reserve the right to monitor, review, flag, or remove any content that violates these Terms, our Child Safety Standards, or our community guidelines. We also reserve the right to suspend or terminate accounts of users who repeatedly violate these Terms.
                  </p>

                  <h4>6. Premium Services and Payments</h4>
                  <p>
                    Certain features, such as therapy sessions or specific premium group memberships, may require payment. All fees and transactions are governed by our payment terms. Payments are non-refundable unless otherwise specified.
                  </p>

                  <h4>7. Limitation of Liability</h4>
                  <p>
                    To the maximum extent permitted by law, Clowza shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses resulting from your use of the Platform.
                  </p>

                  <h4>8. Modification of Terms</h4>
                  <p>
                    We reserve the right to modify these Terms at any time. We will notify you of any material changes by posting the updated Terms on this page. Your continued use of Clowza after changes become effective constitutes acceptance of the new Terms.
                  </p>

                  <h4>9. Contact Us</h4>
                  <p>
                    If you have any questions or concerns regarding these Terms of Service, please contact us at support@clowza.com.
                    For child safety / CSAE concerns, email clowzateam@gmail.com and review our{' '}
                    <a href="https://clowza.com/child-safety-standards.html">Child Safety Standards</a>.
                  </p>

                  <p className="mt-4 text-muted">
                    Last Updated: August 8, 2026
                  </p>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
